import { useState } from 'react';
import { useTutorialContext } from 'context/TutorialContext';
import styled from 'styled-components';

import { Modal } from '@components/Modal';

import { DisplayStep } from './DisplayStep';
import { GeneralInfo } from './GeneralInfo';

export const BookingProcessModal = () => {
  const {
    bookingProcessModalVisibility,
    bookingProcessTutorialExperienceTrigger,
  } = useTutorialContext();

  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const goToNextStep = () => setCurrentStepIndex((prev) => prev + 1);
  const goToPreviousStep = () => setCurrentStepIndex((prev) => prev - 1);
  const onModalCancel = () => {
    if (bookingProcessTutorialExperienceTrigger === 'manual') {
      bookingProcessModalVisibility.hideModal();
    }
  };

  const onModalClose = () => {
    setCurrentStepIndex(0);
  };

  return (
    <StyledModal
      open={bookingProcessModalVisibility.isVisible}
      footer={null}
      onCancel={onModalCancel}
      afterClose={onModalClose}
    >
      <GeneralInfo currentStepIndex={currentStepIndex} />
      <DisplayStep
        goToNextStep={goToNextStep}
        goToPreviousStep={goToPreviousStep}
        currentStepIndex={currentStepIndex}
      />
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  &.ant-modal {
    padding: 0;
    width: 927px !important;
    height: 500px;
    max-width: calc(100vw - 16px);
    top: calc(calc(100% - 500px) / 2);

    @media (max-width: 960px) {
      max-height: none;
      max-width: none;
      margin: 0;
      position: absolute;
      inset: 0;
      width: auto !important;
      height: auto !important;
    }

    > div:first-child {
      height: 100%;
    }

    .ant-modal-content {
      height: 100%;
      border-radius: 0;
      .ant-modal-close {
        display: none;
      }

      .ant-modal-body {
        height: 100%;
        padding: 0;
        display: flex;
        font-size: 14px;
        line-height: 20px;
        max-height: none;
        @media (max-width: 960px) {
          flex-direction: column;
          font-size: 16px;
          line-height: 24px;
        }
      }
    }
  }
`;
